/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export * from './invoke/activity-logs-api';
export * from './invoke/auth-api';
export * from './invoke/controllers-api';
export * from './invoke/customers-api';
export * from './invoke/default-api';
export * from './invoke/equipments-api';
export * from './invoke/failure-trackings-api';
export * from './invoke/groups-api';
export * from './invoke/jobs-api';
export * from './invoke/licenses-api';
export * from './invoke/locations-api';
export * from './invoke/mails-api';
export * from './invoke/notifications-api';
export * from './invoke/posts-api';
export * from './invoke/rpas-api';
export * from './invoke/shipment-certificates-api';
export * from './invoke/treatment-databases-api';
export * from './invoke/treatment-master-lists-api';
export * from './invoke/treatment-monitoring-api';
export * from './invoke/treatment-requests-api';
export * from './invoke/units-api';
export * from './invoke/users-api';
export * from './invoke/variables-api';
export * from './invoke/web-configs-api';

